<div class="navigation-container">
  <navigation-controls (navigationChange)="navigationControlChange($event)"></navigation-controls>
  <div ngbDropdown class="btn-group navigation-dropdown-container">
    <div class="navigation-dropdown-header">
      <input type="text" class="url-input" #urlInput [title]="currentUrl" [value]="currentUrl" (keyup.enter)="onUrlInputEnter(urlInput.value)">
      <button id="navigation-dropdown-btn" class="btn toggle-button bc-input" [title]="'navigationBar.toggleButton' | translate" ngbDropdownToggle>
        <svg-icon icon="arrow-down" class="toggle-icon"></svg-icon>
      </button>
    </div>

    <div class="bc-dropdown dropdown-menu" aria-labelledby="navigation-dropdown-btn">
      <ul>
        <li data-automation-id="assisted-browsing-tabs">
          <span class="dropdown-group-header">{{ 'navigationBar.tabs' | translate }}</span>
          <ul>
            <li *ngFor="let item of visitorTabs; let i = index;"
                [ngClass]="{ 'selected': item.selected }"
                [hidden]="isTabHidden(i)"
                class="dropdown-list-item">
              <svg-icon icon="dot" class="dot-icon"></svg-icon>
              <a class="dropdown-header"
                 (click)="selectTab(item)"
                 [title]="item.title">
                <span>{{ item.title }}</span>
              </a>
            </li>
            <li data-automation-id="assisted-browsing-show-more-tab" *ngIf="visitorTabs.length > visibleTabCount"
                class="dropdown-list-item">
              <a class="dropdown-header"
                 (click)="toggleMoreTabs($event)">
                <span>{{ (showMoreTabs ? 'navigationBar.showLess' : 'navigationBar.showMore') | translate:{ count: visitorTabs.length - visibleTabCount } }}</span>
              </a>
            </li>
          </ul>
        </li>
        <li data-automation-id="assisted-browsing-bookmarks">
          <span class="dropdown-group-header">{{ 'navigationBar.bookmarks' | translate }}</span>
          <ul>
            <li *ngIf="bookmarks.length === 0" class="no-bookmark">
              <span class="dropdown-header">{{ 'navigationBar.noBookmarks' | translate }}</span>
            </li>
            <li *ngFor="let item of bookmarks; let i = index;"
                [hidden]="isBookmarkHidden(i)"
                class="dropdown-list-item">
              <a class="dropdown-header"
                 (click)="selectBookmark(item)"
                 [title]="item.name">
                <span>{{ item.name }}</span>
              </a>
            </li>
            <li data-automation-id="assisted-browsing-show-more-bookmark"
                *ngIf="bookmarks.length > visibleBookmarkCount"
                class="dropdown-list-item">
              <a class="dropdown-header"
                 (click)="toggleMoreBookmarks($event)">
                <span>{{ (showMoreBookmarks ? 'navigationBar.showLess' : 'navigationBar.showMore') | translate:{ count: bookmarks.length - visibleBookmarkCount } }}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
